import axios from '../../../../../../api/axios';

export const fetchingUserData = async (userId) => {
  try {
    const { data: customer } = await axios.get(
      `/api/v1/admin/users/customer/${userId}`
    );
    return customer;
  } catch (error) {
    return error;
  }
};
export const fetchingOrders = async (userId, page = 1, limit = 5,fleetOptions,destination) => {
  try {
    const { data: orders } = await axios.post(
      `/api/v1/admin/users/customer/orders`,
      {
        userId,page,limit,fleetOptions:fleetOptions?.[0]?._id,destination:destination?.value
      }
    );
    return orders;
  } catch (error) {
    return error;
  }
};
export const fetchingNotes = async (userId) => {
  try {
    const { data: notes } = await axios.get(
      `/api/v1/admin/users/${userId}/notes`
    );
    return notes;
  } catch (error) {
    return error;
  }
};
export const fetchingPhones = async (userId) => {
  try {
    const { data: {phones} } = await axios.get(
      `/api/v1/admin/users/customer/${userId}/phones/all`
    );
    return phones;
  } catch (error) {
    throw error;
  }
};
export const fetchingSms = async (userId, page = 1, limit = 5) => {
  try {
    const { data: allSms } = await axios.get(
      `/api/v1/admin/users/customer/${userId}/sms/${page}/${limit}`
    );
    return allSms;
  } catch (error) {
    return error;
  }
};
export const fetchingMessages = async (userId, page = 1, limit = 5) => {
  try {
    const { data: messages } = await axios.get(
      `/api/v1/admin/users/customer/${userId}/messages/${page}/${limit}`
    );
    return messages;
  } catch (error) {
    return error;
  }
};
export const fetchingNotifications = async (userId, page = 1, limit = 5) => {
  try {
    return [];
  } catch (error) {
    return error;
  }
};
export const fetchingTransactions = async (userId, page = 1, limit = 5) => {
  try {
    const { data: transactions } = await axios.get(
      `/api/v1/admin/users/customer/${userId}/transactions/${page}/${limit}`
    );
    return transactions;
  } catch (error) {
    return error;
  }
};
export const addNote = async (userId, note) => {
  try {
    const { data } = await axios.post(`/api/v1/admin/users/addNote`, {
      userId,
      note,
    });
    return data;
  } catch (error) {
    return error;
  }
};

export const deleteNote = async (noteId) => {
  try {
    const { data } = await axios.delete(
      `/api/v1/admin/users/deleteNote/${noteId}`
    );
    return data;
  } catch (error) {
    return error;
  }
};
